import { apiAxiosAuth } from 'services/api';
import { CredentialChild } from 'types/ProvidersProps';

interface RespProps {
	isSuccess: boolean;
	data: CredentialChild | null;
}
export async function editProvider(credential: CredentialChild) {
	const resp: RespProps = { isSuccess: false, data: null };

	await apiAxiosAuth
		.patch('credentials', {
			credential: credential.credential,
			slug: credential.slug
		})
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res.data;
		})
		.catch(() => {
			resp.isSuccess = false;
			resp.data = null;
		});

	return resp;
}
